const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "soundwave",
  transform: "translate(-1 -1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_22695",
  "data-name": "Path 22695",
  d: "M2.667,10A1.667,1.667,0,0,0,1,11.667V28.333a1.667,1.667,0,1,0,3.333,0V11.667A1.667,1.667,0,0,0,2.667,10Z",
  transform: "translate(0 6)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_22696",
  "data-name": "Path 22696",
  d: "M6.667,5A1.667,1.667,0,0,0,5,6.667V40a1.667,1.667,0,0,0,3.333,0V6.667A1.667,1.667,0,0,0,6.667,5Z",
  transform: "translate(2.667 2.667)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_22697",
  "data-name": "Path 22697",
  d: "M18.667,10A1.667,1.667,0,0,0,17,11.667V28.333a1.667,1.667,0,1,0,3.333,0V11.667A1.667,1.667,0,0,0,18.667,10Z",
  transform: "translate(10.667 6)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_22698",
  "data-name": "Path 22698",
  d: "M14.667,5A1.667,1.667,0,0,0,13,6.667V40a1.667,1.667,0,0,0,3.333,0V6.667A1.667,1.667,0,0,0,14.667,5Z",
  transform: "translate(8 2.667)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_22699",
  "data-name": "Path 22699",
  d: "M10.667,1A1.667,1.667,0,0,0,9,2.667V49.333a1.667,1.667,0,1,0,3.333,0V2.667A1.667,1.667,0,0,0,10.667,1Z",
  transform: "translate(5.333)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_22700",
  "data-name": "Path 22700",
  d: "M30.667,10A1.667,1.667,0,0,0,29,11.667V28.333a1.667,1.667,0,1,0,3.333,0V11.667A1.667,1.667,0,0,0,30.667,10Z",
  transform: "translate(18.667 6)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_22701",
  "data-name": "Path 22701",
  d: "M26.667,5A1.667,1.667,0,0,0,25,6.667V40a1.667,1.667,0,0,0,3.333,0V6.667A1.667,1.667,0,0,0,26.667,5Z",
  transform: "translate(16 2.667)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_22702",
  "data-name": "Path 22702",
  d: "M22.667,1A1.667,1.667,0,0,0,21,2.667V49.333a1.667,1.667,0,1,0,3.333,0V2.667A1.667,1.667,0,0,0,22.667,1Z",
  transform: "translate(13.333)",
  fill: "#fff"
}));
function SvgSoundwaveWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundwaveWhite);
export default __webpack_public_path__ + "static/media/soundwaveWhite.c5912d9b38f760fc077cc35864d40c6d.svg";
export { ForwardRef as ReactComponent };